export default __webpack_public_path__ + "static/media/dashboard-icon.c8de62ff.svg";